import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-file-manager',
  templateUrl: './file-manager.component.html',
  standalone: false
})
export class FileManagerComponent implements OnInit {
  @Output() selectedFiles = new EventEmitter<[]>();
  @Output() deletedFilesList = new EventEmitter<[]>();

  @Input() isRequired!: boolean;
  @Input() Disapled!: boolean;
  @Input() isSubmitted!: boolean;
  @Input() cols = 1;
  @Input() label!: string;
  @Input() supportedText!: string;
  @Input() showMaxSize: boolean = true;
  @Input() showExtensions: boolean = true;
  @Input() showAttachmentsTitle!: boolean;

  @Input() allowedExt: any[] = [
    'pdf',
    'jpeg',
    'jpg',
    'png',
    'doc',
    'docx',
    'wpd',
    'tex',
    'ppt',
    'pptx',
    'xlsx',
    'xls',
    'zip',
    'rar',
    'mp4',
    'json'
  ];
  acceptExt = '';

  @Input() renderBtn = false;

  // Uploader
  @Input() isUploader = false;
  @Input() uplodaerType = 0;
  uploadedFilesArr: any = [];

  // DnD setting
  @Input() files: any = [];
  @Input() docsEditable = true;
  @Input() maxFiles!: number;
  @Input() maxSize = 5;
  @Input() managerIndex: any = '0'; // in add numbertab_numberneeded, in details numbertab_d_numberneeded in "''"

  loading = false;
  selectedfilesCount = 0;
  deletedFiles: any = [];
  invalidFile = false;
  fileMaxSiZeErorr = false;
  fileMaxNameSiZeErorr = false;

  constructor(
    // private service: CabsRequestService,
    private readonly translate: TranslateService
  ) { }

  ngOnInit() {
    if (this.files.length && this.isUploader) {
      this.files.forEach((file: any) => {
        this.uploadedFilesArr.push({
          fileName: file.name,
          fileUpload: file.token,
        });
      });
      this.selectedFiles.emit(this.uploadedFilesArr);
    }

    if (this.allowedExt.includes('pdf')) {
      this.acceptExt += 'application/pdf, ';
    }
    if (this.allowedExt.includes('jpeg') || this.allowedExt.includes('jpg')) {
      this.acceptExt += 'image/jpeg, ';
    }
    if (this.allowedExt.includes('png')) {
      this.acceptExt += 'image/png, ';
    }
    this.allowedExt.forEach((element) => {
      this.acceptExt += '.' + element + ', ';
    });
  }

  fileType(fileName: any) {
    const extension = fileName.split('.').pop().toLowerCase();
    if (!this.allowedExt.includes(extension)) {
      return false;
    }
    switch (extension) {
      case 'mp4':
        return 'mp4';
      case 'mkv':
        return 'mkv';
      case 'avi':
        return 'avi';
      case 'mov':
        return 'mov';
      case 'pdf':
        return 'pdf';
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      case 'doc':
      case 'docx':
      case 'wpd':
      case 'tex':
        return 'doc';
      case 'xlsx':
      case 'xls':
        return 'xls';
      case 'zip':
      case 'rar':
        return 'zip';
      case 'ppt':
      case 'pptx':
        return 'pptx';
      case 'svs':
      case 'tif':
      case 'ndpi':
      case 'scn':
      case 'mrxs':
      case 'svslide':
      case 'bif':
        return 'wsi';
      case 'json':
        return 'json';
      case 'txt':
        return 'txt';
      case 'crt':
        return 'crt';
      case 'cer':
        return 'cer';
      case 'pfx':
        return 'pfx';
      default:
        return false;
    }
  }

  /**
   * on file drop handler
   */
  onFileDropped($event: any) {
    if (!this.Disapled) {
      this.prepareFilesList($event);
    }
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(input: HTMLInputElement | null) {
    if (!input || !input.files || input.files.length === 0) return;
    this.prepareFilesList(Array.from(input.files)); // ← FileList ⇒ Array<File>
    input.value = ''; // reset
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number, id: any) {
    if (id) {
      this.deletedFiles.push(id);
    }

    const deleted = this.files[index];
    this.files.splice(index, 1);

    if (this.isUploader) {
      const deletedIndx = this.uploadedFilesArr.findIndex(
        (item: any) => item.fileUpload === deleted.token
      );
      this.uploadedFilesArr.splice(deletedIndx, 1);
      this.selectedFiles.emit(this.uploadedFilesArr);
    } else {
      this.selectedFiles.emit(this.files);
      this.deletedFilesList.emit(this.deletedFiles);
    }
    this.selectedfilesCount = this.files.length;
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {

    this.invalidFile = false;
    this.fileMaxSiZeErorr = false;
    this.selectedfilesCount = this.files.length + files.length;
    if (this.selectedfilesCount > this.maxFiles) {
      return;
    }
    for (const item of files) {
      const nameOk = this.isAllowedName(item.name) && !this.hasSuspiciousExtension(item.name);
      const extOk = !!this.fileType(item.name);
      const sizeOk = (item.size / (1024 * 1024)) <= this.maxSize;
      const mimeOk = this.isAllowedMime(item as File);

      if (!nameOk) this.fileMaxNameSiZeErorr = true;
      if (!extOk) this.invalidFile = true;
      if (!sizeOk) this.fileMaxSiZeErorr = true;

      if (nameOk && extOk && sizeOk && mimeOk) {
        item.fileType = this.fileType(item.name);
        this.files.push(item);
        this.selectedFiles.emit(this.files);
      }
    }
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  uploadFile(files: any) {
    this.loading = true;
    this.Disapled = true;
    // this.service.upload_file(files, this.uplodaerType).subscribe(
    //   (response) => {
    //     this.loading = false;
    //     this.Disapled = false;
    //     this.uploadedFilesArr.push(response.data);
    //     this.selectedFiles.emit(this.uploadedFilesArr);
    //   },
    //   (err) => {
    //     this.loading = false;
    //     this.Disapled = false;
    //   }
    // );
  }

  safeDownload(p: string | null | undefined): string | null {
    if (!p || typeof p !== 'string') return null;
    try {
      const u = new URL(p, window.location.origin);
      const sameOrigin = u.origin === window.location.origin;
      // enforce your allowed prefix; change "/files/" to your real download path
      if (sameOrigin && u.pathname.startsWith('/files/')) return u.toString();
      // if you legitimately serve from a CDN, allowlist its origin(s) here:
      // const allowed = ['https://cdn.example.com'];
      // if (allowed.includes(u.origin)) return u.toString();
      return null;
    } catch { return null; }
  }
  private isAllowedName(name: string): boolean {
    const n = name.normalize('NFC');

    if (n.length > 180) return false;

    if (/[\\\/]/.test(n)) return false; // no slashes
    if (/[<>:"|?*\x00-\x1F]/.test(n)) return false; // no control chars or OS-reserved
    if (n.startsWith('.')) return false; // hidden/system files

    return /^[\p{L}\p{N}\s.\-_()[\]{}+&,؛،]+$/u.test(n);
  }


  private hasSuspiciousExtension(name: string): boolean {
    const n = name.toLowerCase();
    if (n.startsWith('.')) return true;
    const parts = n.split('.');
    if (parts.length <= 2) return false;
    const last = parts.pop()!;
    const earlier = parts.slice(1);
    const bad = ['exe', 'bat', 'cmd', 'sh', 'ps1', 'js', 'mjs', 'vbs', 'jar', 'msi', 'dll', 'com', 'scr'];
    if (!this.allowedExt.includes(last)) return true;
    return earlier.some(e => bad.includes(e));
  }

  private isAllowedMime(file: File): boolean {
    const t = (file.type || '').toLowerCase();
    if (!t) return true; // بعض الملفات لا تُرسل MIME مضبوطاً

    const allow = [
      // Office formats
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',

      // PDFs
      'application/pdf',

      // Images
      'image/jpeg',
      'image/png',

      // Archives
      'application/zip',
      'application/x-zip-compressed',
      'application/x-rar-compressed',

      // Text & JSON
      'text/plain',
      'application/json',

      // Videos
      'video/mp4',
      'video/x-msvideo', // avi
      'video/x-matroska', // mkv
      'video/quicktime' // mov
    ];

    return allow.includes(t);
  }

}
